(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4604],{

/***/ 57307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84751);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Icon = function Icon(_ref) {
  var className = _ref.className,
      name = _ref.name;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Icon), className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
    className: classes,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("use", {
      xlinkHref: "#".concat(name)
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 80751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var CoubicShortLogo = function CoubicShortLogo(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
    className: className,
    viewBox: "0 0 97 41",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("g", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M27.538 4.201a8.446 8.446 0 00-4.682 1.416 8.407 8.407 0 00-3.104 3.77 8.376 8.376 0 001.828 9.156 8.451 8.451 0 009.184 1.82 8.421 8.421 0 003.782-3.096 8.381 8.381 0 00-1.05-10.607 8.426 8.426 0 00-5.958-2.459zm0 13.647a5.277 5.277 0 01-2.924-.886 5.251 5.251 0 01-1.938-2.356 5.233 5.233 0 011.143-5.718 5.27 5.27 0 015.737-1.137 5.261 5.261 0 012.362 1.933 5.236 5.236 0 01-.656 6.627 5.265 5.265 0 01-3.724 1.537zM79.668 7.088h-3.264v13.385h3.264V7.088zM65.031 4.201a8.404 8.404 0 00-5.267 1.842V0H56.61v12.6c0 1.661.494 3.285 1.42 4.667a8.42 8.42 0 003.78 3.095 8.452 8.452 0 009.185-1.82 8.376 8.376 0 001.828-9.155 8.406 8.406 0 00-3.104-3.77 8.446 8.446 0 00-4.682-1.416h-.007zm0 13.647a5.276 5.276 0 01-2.925-.885 5.251 5.251 0 01-1.939-2.355 5.232 5.232 0 011.141-5.72 5.27 5.27 0 015.738-1.137 5.261 5.261 0 012.362 1.933 5.236 5.236 0 01-.654 6.627 5.273 5.273 0 01-3.723 1.537zM80.141 2.625a2.092 2.092 0 01-1.299 1.941 2.11 2.11 0 01-2.295-.456 2.1 2.1 0 01-.618-1.485c0-.556.223-1.09.618-1.484a2.11 2.11 0 012.978 0c.394.394.616.928.616 1.484zM87.32 16.31a5.24 5.24 0 010-7.422 5.273 5.273 0 017.446 0L97 6.663a8.449 8.449 0 00-9.181-1.822 8.42 8.42 0 00-3.782 3.093 8.38 8.38 0 000 9.332 8.419 8.419 0 003.781 3.094A8.448 8.448 0 0097 18.537l-2.234-2.227a5.275 5.275 0 01-7.447 0zM53.444 13.651a7.337 7.337 0 01-2.159 5.197A7.384 7.384 0 0146.072 21a7.384 7.384 0 01-5.212-2.152 7.337 7.337 0 01-2.16-5.197V4.726h3.267v8.925a4.09 4.09 0 001.237 2.831 4.114 4.114 0 005.739 0 4.09 4.09 0 001.237-2.83V4.725h3.264v8.925zM10.531 17.61a7.153 7.153 0 01-3.385-.847 7.126 7.126 0 01-2.577-2.347 7.097 7.097 0 011.515-9.485 7.145 7.145 0 016.663-1.19 7.138 7.138 0 012.95 1.86l2.281-2.526A10.572 10.572 0 006.57.742a10.536 10.536 0 00-4.746 3.79A10.486 10.486 0 001.62 16.14a10.532 10.532 0 004.61 3.954 10.57 10.57 0 0011.483-1.935l-2.139-2.632a7.105 7.105 0 01-5.044 2.084z"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("g", {
      fill: "#9EA5B2",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M81.074 38.183c0 .529-.155.824-.653.897-.452.04-.907.044-1.36.016l-.2-.873c.356.029.714.037 1.07.023.17-.015.219-.096.219-.249v-2.878h-3.264v-.773h3.302a9.958 9.958 0 00-1.327-.967l.603-.53c.42.25.79.49 1.128.738.387-.289.777-.61 1.104-.914h-3.643v-.774h4.764l.57.386a17.348 17.348 0 01-2.217 1.79c.105.088.277.28.277.28h2.251l.547.133a14.08 14.08 0 01-1.553 2.217l-.951-.265c.388-.407.743-.844 1.062-1.307h-1.729v3.05zM87.407 39.103h-.862v-3.14c-.516.058-1.007.106-1.377.137l-.155-.801.556-.024c.233-.281.459-.569.684-.866a8.131 8.131 0 00-1.16-1.116l.467-.577c.08.065.155.129.233.194.291-.392.55-.806.777-1.238l.777.337c-.303.489-.634.96-.99 1.411.13.129.249.257.354.378.33-.452.636-.92.919-1.404l.788.36a28.476 28.476 0 01-1.865 2.477l1.159-.072a5.542 5.542 0 00-.426-.619l.668-.345c.081.104.156.208.234.32a6.824 6.824 0 001.15-2.838l.871.154c-.072.39-.168.776-.289 1.155h2.527c-.064 3.52-.232 5.477-.547 5.907-.142.176-.342.21-.64.21h-.972l-.144-.858c.258.017.668.029.86.02.12 0 .172-.016.229-.112.146-.249.278-1.6.31-4.358h-1.938c-.18.395-.396.774-.644 1.13l-.74-.377c.27.392.49.815.66 1.26-.258.128-.476.24-.694.352a3.953 3.953 0 00-.136-.345c-.193.024-.41.048-.644.064v3.224zm-1.104-2.611a7.155 7.155 0 01-.647 2.094c-.015-.009-.03-.017-.727-.309.319-.61.53-1.27.622-1.953l.752.168zm2.091-.223c.247.525.437 1.076.567 1.641-.29.1-.525.186-.767.266a7.139 7.139 0 00-.55-1.632l.75-.275zm1.33-1.411a6.375 6.375 0 011.399 1.737l-.745.503a6.008 6.008 0 00-1.281-1.76l.627-.48z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M43.81 35.404v.021c0 2.11 1.642 3.819 3.942 3.819 2.3 0 3.965-1.729 3.965-3.84v-.021c0-2.111-1.644-3.819-3.943-3.819-2.3 0-3.964 1.73-3.964 3.84zm6.195 0v.021c0 1.271-.92 2.312-2.237 2.312-1.317 0-2.253-1.06-2.253-2.333v-.021c0-1.273.907-2.313 2.231-2.313 1.325 0 2.26 1.061 2.26 2.334zm-13.057-2.207h2.33v5.917h1.665v-5.917h2.323V31.69h-6.318v1.507zm16.138-1.507h3.362c.945 0 1.679.266 2.167.754.415.414.639.996.639 1.697v.02c0 1.2-.65 1.953-1.595 2.303l1.817 2.65h-1.913l-1.593-2.373h-1.248v2.373h-1.636V31.69zm3.22 3.606c.798 0 1.255-.423 1.255-1.049v-.021c0-.699-.489-1.055-1.282-1.055h-1.592v2.136l1.62-.01zm9.971-3.606h-5.572v7.424h5.626v-1.452h-4v-1.559h3.468V34.65H62.33v-1.506h3.947V31.69zm4.835 2.98c-1.285-.328-1.603-.487-1.603-.974v-.022c0-.356.33-.646.95-.646.555 0 1.126.214 1.704.578l1.081-1.078a4.313 4.313 0 00-2.763-.943c-1.52 0-2.603.89-2.603 2.237v.022c0 1.474.967 1.888 2.465 2.27 1.244.318 1.498.53 1.498.949v.021c0 .436-.403.7-1.07.7-.805 0-1.476-.314-2.115-.816l-1.07 1.068a4.74 4.74 0 003.157 1.186c1.604 0 2.734-.83 2.734-2.301v-.022c-.005-1.294-.855-1.83-2.365-2.228zm-38.866-.974c0 .487.32.646 1.605.975 1.504.399 2.359.934 2.37 2.228v.022c0 1.47-1.13 2.301-2.735 2.301a4.743 4.743 0 01-3.156-1.186l1.07-1.068c.638.502 1.31.816 2.115.816.665 0 1.07-.264 1.07-.7v-.021c0-.419-.256-.631-1.498-.95-1.5-.381-2.466-.795-2.466-2.27v-.02c0-1.347 1.084-2.238 2.604-2.238a4.315 4.315 0 012.762.943l-1.08 1.078c-.58-.364-1.15-.578-1.704-.578-.626 0-.957.29-.957.646v.022z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
        d: "M23.732 29.052c-1.776.625-3.415 1.85-4.563 3.373-2.76 3.347-1.967 6.34 3.443 5.714 2.841-.3 1.748-3.727-.765-1.932-3.28 2.395-1.94 6.367 2.021 4.136 4.017-2.34 5.165-8.489-1.83-7.101-1.694.326-1.558 2.639.273 2.312 1.257-.217 2.842-2.122 2.842-3.51 0-.788-.547-1.278-1.093-1.115-.52.163-.52.898-.082 1.061.628.218-.082 1.578-1.476 2.476-.546.354-.82-.136-.19-.245 3.032-.517 4.016.436 3.578 2.014-.491 1.523-1.475 2.693-2.923 3.373-2.486 1.143-2.377-.98-.71-2.53.846-.707 1.256-.136.491 0-1.557.218-5.519.653-3.415-2.993 1.257-2.177 3.306-3.564 4.863-4 .629-.244.41-1.333-.464-1.033zM5.336 36.945v.618h-.899V32h.9v2.147c.116-.22.292-.404.507-.535.215-.13.463-.2.716-.205.833 0 1.665.691 1.665 2.074v.105c0 1.383-.783 2.074-1.665 2.074a1.457 1.457 0 01-.71-.198 1.415 1.415 0 01-.514-.517zm1.957-1.391v-.073c0-.814-.442-1.326-.974-1.326-.533 0-1 .512-1 1.318v.08c0 .814.459 1.31 1 1.31.54 0 .974-.496.974-1.31zM11.846 33.464h.924l-1.423 4.156c-.284.813-.625 1.13-1.24 1.13a1.693 1.693 0 01-.858-.244l.258-.667c.148.081.313.129.483.138.241 0 .383-.105.507-.43l-1.49-4.067h.95l.957 2.96.932-2.976z"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CoubicShortLogo);

/***/ }),

/***/ 43830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_GlobalFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/GlobalFooter/index.module.scss
var index_module = __webpack_require__(60267);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/contexts/LocaleContext.tsx + 9 modules
var LocaleContext = __webpack_require__(85969);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterAccordion.tsx
var ServiceFooterAccordion = __webpack_require__(16784);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterLogo.tsx
var ServiceFooterLogo = __webpack_require__(53447);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterSectionBody.tsx + 1 modules
var ServiceFooterSectionBody = __webpack_require__(47544);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/atoms/icons/Icon/index.tsx
var Icon = __webpack_require__(57307);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterSingleHeadingAccordion.module.scss
var ServiceFooterSingleHeadingAccordion_module = __webpack_require__(88526);
var ServiceFooterSingleHeadingAccordion_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFooterSingleHeadingAccordion_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/common/ServiceFooterSingleHeadingAccordion.tsx







var ServiceFooterSingleHeadingAccordion = function ServiceFooterSingleHeadingAccordion(props) {
  var classes = classnames_default()((ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion, props.className);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      id: props.name,
      type: "checkbox",
      className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Input
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
      htmlFor: props.name,
      className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Head,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Head__Brand,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Head__Copy,
          children: props.copy
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
        name: "descend-gr",
        className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Head__Icon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServiceFooterSingleHeadingAccordion_module_default()).ServiceFooterSingleHeadingAccordion__Show,
      children: props.children
    })]
  });
};

/* harmony default export */ var common_ServiceFooterSingleHeadingAccordion = (ServiceFooterSingleHeadingAccordion);
// EXTERNAL MODULE: ./src/components/layouts/GlobalFooter/ServiceFooter.module.scss
var ServiceFooter_module = __webpack_require__(83281);
var ServiceFooter_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFooter_module);
;// CONCATENATED MODULE: ./src/components/layouts/GlobalFooter/ServiceFooter.tsx












var ServiceFooter = function ServiceFooter() {
  var intl = (0,useIntl/* default */.Z)();
  var localeCtx = (0,react.useContext)(LocaleContext/* LocaleContext */.RD);
  var intlPref = 'components.common.layouts.globalFooter.serviceFooter.';
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ServiceFooter_module_default()).ServiceFooter,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (ServiceFooter_module_default()).ServiceFooter__Inner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (ServiceFooter_module_default()).ServiceFooter__LinkSection,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterLogo/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
          buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
          buttonColor: Button/* ButtonColor.Biz */.rp.Biz,
          className_Deprecated: (ServiceFooter_module_default()).ServiceFooter__Button,
          href: "https://stores.jp/reserve",
          children: intl.formatMessage({
            id: intlPref + 'buttons.startTrial'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterAccordion/* default */.Z, {
        className: (ServiceFooter_module_default()).ServiceFooter__ContentSection,
        name: "footer-business",
        copy: intl.formatMessage({
          id: intlPref + 'copies.business'
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterSectionBody/* default */.Z, {
          rows: [{
            heading: intl.formatMessage({
              id: intlPref + 'headings.service'
            }),
            links: [{
              url: 'https://stores.jp/reserve',
              text: intl.formatMessage({
                id: intlPref + 'links.business'
              })
            }, {
              url: '/inquiry',
              text: intl.formatMessage({
                id: intlPref + 'links.inquiry'
              })
            }, {
              url: 'https://go.coubic.com/doc_feature.html',
              text: intl.formatMessage({
                id: intlPref + 'links.requestDoc'
              })
            }, {
              url: 'https://go.coubic.com/movie_demo.html',
              text: intl.formatMessage({
                id: intlPref + 'links.demoMovie'
              })
            }, {
              url: 'https://stores.jp/reserve/features',
              text: intl.formatMessage({
                id: intlPref + 'links.features'
              })
            }, {
              url: 'https://stores.jp/reserve/advantages',
              text: intl.formatMessage({
                id: intlPref + 'links.advantages'
              })
            }, {
              url: 'https://stores.jp/reserve/integrations',
              text: intl.formatMessage({
                id: intlPref + 'links.integrations'
              })
            }, {
              url: 'https://stores.jp/reserve/cases',
              text: intl.formatMessage({
                id: intlPref + 'links.cases'
              })
            }, {
              url: 'https://stores.jp/reserve/pricing',
              text: intl.formatMessage({
                id: intlPref + 'links.pricing'
              })
            }, {
              url: 'https://stores.jp/reserve/faq',
              text: intl.formatMessage({
                id: intlPref + 'links.faq'
              })
            } // # リソース不足のため一時的にクローズする see: https://github.com/heyinc/rsv-issues/issues/16266
            // {
            //   url: '/partnership/become_partner',
            //   text: intl.formatMessage({
            //     id: intlPref + 'links.partners',
            //   }),
            // },
            ]
          }, {
            heading: intl.formatMessage({
              id: intlPref + 'headings.bizCategory'
            }),
            links: [// TODO: merchant_categoryがpath情報もってない
            {
              url: 'https://stores.jp/reserve/categories/yoga',
              text: intl.formatMessage({
                id: intlPref + 'links.yoga'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/massage_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.massage'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/fitness_school',
              text: intl.formatMessage({
                id: intlPref + 'links.fitness_school'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/online_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.online_lessons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/hair_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.hairsalons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/nail_salons',
              text: intl.formatMessage({
                id: intlPref + 'links.nailsalons'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/spaces',
              text: intl.formatMessage({
                id: intlPref + 'links.spaces'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/exhibitions',
              text: intl.formatMessage({
                id: intlPref + 'links.exhibitions'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.classes'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/seminar',
              text: intl.formatMessage({
                id: intlPref + 'links.seminar'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/recruiting',
              text: intl.formatMessage({
                id: intlPref + 'links.recruiting'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/communities',
              text: intl.formatMessage({
                id: intlPref + 'links.community'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/events',
              text: intl.formatMessage({
                id: intlPref + 'links.events'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/tourism',
              text: intl.formatMessage({
                id: intlPref + 'links.tourism'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/experts',
              text: intl.formatMessage({
                id: intlPref + 'links.experts'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/cooking_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.cooking_class'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/golf_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.golf_lesson'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/language_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.language_school'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/pc_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.pc_class'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/sports_lessons',
              text: intl.formatMessage({
                id: intlPref + 'links.sports_lesson'
              })
            }, {
              url: 'https://stores.jp/reserve/categories/others',
              text: intl.formatMessage({
                id: intlPref + 'links.other'
              })
            }]
          }]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(common_ServiceFooterSingleHeadingAccordion, {
        className: (ServiceFooter_module_default()).ServiceFooter__ContentSection,
        name: 'footer-company',
        copy: intl.formatMessage({
          id: intlPref + 'copies.company'
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceFooterSectionBody/* default */.Z, {
          rows: [{
            links: [{
              url: 'https://coubic.com/terms',
              text: intl.formatMessage({
                id: intlPref + 'links.terms'
              })
            }, {
              url: 'https://id.stores.jp/privacy_policy',
              text: intl.formatMessage({
                id: intlPref + 'links.policyForMerchant'
              })
            }, {
              url: 'https://stores.jp/reserve/privacy',
              text: intl.formatMessage({
                id: intlPref + 'links.policyForEndUser'
              })
            }, {
              url: 'https://coubic.com/legal_notice',
              text: intl.formatMessage({
                id: intlPref + 'links.sct'
              })
            }]
          }]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (ServiceFooter_module_default()).ServiceFooter__ContentSection,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (ServiceFooter_module_default()).ServiceFooter__Language,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [intl.formatMessage({
              id: intlPref + 'language'
            }), "\uFF1A"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
            className: (ServiceFooter_module_default()).ServiceFooter__LanguageSelect,
            onChange: function onChange(e) {
              localeCtx.changeLocale(e.target.value);
            },
            value: localeCtx.currentLocale,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: "ja",
              children: "\u65E5\u672C\u8A9E"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: "en",
              children: "English"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: "ko",
              children: "\uD55C\uAD6D\uC5B4"
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var GlobalFooter_ServiceFooter = (ServiceFooter);
// EXTERNAL MODULE: ./src/components/layouts/GlobalFooter/SiteFooter.module.scss
var SiteFooter_module = __webpack_require__(4987);
var SiteFooter_module_default = /*#__PURE__*/__webpack_require__.n(SiteFooter_module);
;// CONCATENATED MODULE: ./src/components/layouts/GlobalFooter/SiteFooter.tsx





var SiteFooter = function SiteFooter() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (SiteFooter_module_default()).SiteFooter,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (SiteFooter_module_default()).SiteFooter__Inner,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SiteFooter_module_default()).SiteFooter__Section,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SiteFooter_module_default()).SiteFooter__NavBox,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: (SiteFooter_module_default()).SiteFooter__Nav,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (SiteFooter_module_default()).SiteFooter__NavTitle,
              children: "\u95A2\u9023\u30B5\u30FC\u30D3\u30B9"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: (SiteFooter_module_default()).SiteFooter__NavList,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__NavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://stores.jp/ec?source=internal&medium=referral&campaign=re2ec_footer",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "STORES\uFF08\u30CD\u30C3\u30C8\u30B7\u30E7\u30C3\u30D7\uFF09"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__NavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://coiney.com?source=internal&medium=referral&campaign=re2pa_footer",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "STORES \u6C7A\u6E08\uFF08\u30AD\u30E3\u30C3\u30B7\u30E5\u30EC\u30B9\u6C7A\u6E08\uFF09"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__NavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://stores.jp/regi?source=internal&medium=referral&campaign=re2rg_footer",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "STORES \u30EC\u30B8\uFF08POS\u30EC\u30B8\uFF09"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__NavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://stores.jp/brandedapp",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "STORES \u30D6\u30E9\u30F3\u30C9\u30A2\u30D7\u30EA (\u5E97\u8217\u30A2\u30D7\u30EA\u4F5C\u6210)"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
            className: (SiteFooter_module_default()).SiteFooter__Nav,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (SiteFooter_module_default()).SiteFooter__NavTitle,
              children: "\u304A\u5F79\u7ACB\u3061\u30B3\u30F3\u30C6\u30F3\u30C4"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (SiteFooter_module_default()).SiteFooter__NavList,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__NavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://officialmag.stores.jp",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "STORES Magazine"
                })
              })
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SiteFooter_module_default()).SiteFooter__Section,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (SiteFooter_module_default()).SiteFooter__BottomNav,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
            className: (SiteFooter_module_default()).SiteFooter__Nav,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: (SiteFooter_module_default()).SiteFooter__BottomNavList,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__BottomNavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://st.inc",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "\u904B\u55B6\u4F1A\u793E"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__BottomNavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://jobs.st.inc",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "\u63A1\u7528\u60C5\u5831"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: (SiteFooter_module_default()).SiteFooter__BottomNavListItem,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  href: "https://st.inc/news",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: (SiteFooter_module_default()).SiteFooter__NavListLink,
                  children: "\u304A\u77E5\u3089\u305B"
                })
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (SiteFooter_module_default()).SiteFooter__Copyright,
            children: "STORES, Inc."
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var GlobalFooter_SiteFooter = (SiteFooter);
;// CONCATENATED MODULE: ./src/components/layouts/GlobalFooter/index.tsx







var GlobalFooter = function GlobalFooter() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
    className: (index_module_default()).GlobalFooter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GlobalFooter_ServiceFooter, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalFooter_SiteFooter, {})]
  });
};

/* harmony default export */ var layouts_GlobalFooter = (GlobalFooter);

/***/ }),

/***/ 16784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_icons_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57307);
/* harmony import */ var _ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49939);
/* harmony import */ var _ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var ServiceFooterAccordion = function ServiceFooterAccordion(props) {
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion), props.className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("input", {
      id: props.name,
      type: "checkbox",
      className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Input)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("label", {
      htmlFor: props.name,
      className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Head),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Head__Brand),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Head__Copy),
          children: props.copy
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_icons_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        name: "descend-gr",
        className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Head__Icon)
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: (_ServiceFooterAccordion_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ServiceFooterAccordion__Show),
      children: props.children
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ServiceFooterAccordion);

/***/ }),

/***/ 53447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _atoms_logos_CoubicShortLogo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80751);
/* harmony import */ var _ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78561);
/* harmony import */ var _ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var ServiceFooterLogo = function ServiceFooterLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: (_ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ServiceFooterLogo),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      href: "/",
      className: (_ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ServiceFooterLogo__Logo),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_logos_CoubicShortLogo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: (_ServiceFooterLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ServiceFooterLogo__LogoImg)
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ServiceFooterLogo);

/***/ }),

/***/ 47544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_ServiceFooterSectionBody; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterSectionRow.module.scss
var ServiceFooterSectionRow_module = __webpack_require__(72897);
var ServiceFooterSectionRow_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFooterSectionRow_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/common/ServiceFooterSectionRow.tsx





var ServiceFooterSectionRow = function ServiceFooterSectionRow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (ServiceFooterSectionRow_module_default()).ServiceFooterSectionRow,
    children: [props.heading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (ServiceFooterSectionRow_module_default()).ServiceFooterSectionRow__Head,
      children: props.heading
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (ServiceFooterSectionRow_module_default()).ServiceFooterSectionRow__BodyList,
      children: props.links.map(function (link, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: index !== props.links.length - 1 ? (ServiceFooterSectionRow_module_default()).ServiceFooterSectionRow__BodyListItem : (ServiceFooterSectionRow_module_default()).ServiceFooterSectionRow__BodyListItemLast,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: link.url,
            children: link.text
          })
        }, index);
      })
    })]
  });
};

/* harmony default export */ var common_ServiceFooterSectionRow = (ServiceFooterSectionRow);
// EXTERNAL MODULE: ./src/components/layouts/common/ServiceFooterSectionBody.module.scss
var ServiceFooterSectionBody_module = __webpack_require__(37412);
var ServiceFooterSectionBody_module_default = /*#__PURE__*/__webpack_require__.n(ServiceFooterSectionBody_module);
;// CONCATENATED MODULE: ./src/components/layouts/common/ServiceFooterSectionBody.tsx





var ServiceFooterSectionBody = function ServiceFooterSectionBody(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (ServiceFooterSectionBody_module_default()).ServiceFooterSectionBody,
    children: props.rows.map(function (row, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(common_ServiceFooterSectionRow, {
        heading: row.heading,
        links: row.links
      }, index);
    })
  });
};

/* harmony default export */ var common_ServiceFooterSectionBody = (ServiceFooterSectionBody);

/***/ }),

/***/ 84751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__HjWlJ"};

/***/ }),

/***/ 83281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooter":"ServiceFooter_ServiceFooter__cG4zB","ServiceFooter__Inner":"ServiceFooter_ServiceFooter__Inner__vymgU","ServiceFooter__LinkSection":"ServiceFooter_ServiceFooter__LinkSection__bupPF","ServiceFooter__StoreBadge":"ServiceFooter_ServiceFooter__StoreBadge__OhDdL","ServiceFooter__StoreBadgeImage":"ServiceFooter_ServiceFooter__StoreBadgeImage__VSg5s","ServiceFooter__Button":"ServiceFooter_ServiceFooter__Button__HRc18","ServiceFooter__ContentSection":"ServiceFooter_ServiceFooter__ContentSection__117q4","ServiceFooter__Language":"ServiceFooter_ServiceFooter__Language__xkQcP","ServiceFooter__LanguageSelect":"ServiceFooter_ServiceFooter__LanguageSelect__d4Zpk"};

/***/ }),

/***/ 4987:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SiteFooter":"SiteFooter_SiteFooter__Mt9Q4","SiteFooter__Inner":"SiteFooter_SiteFooter__Inner__o4K3k","SiteFooter__Section":"SiteFooter_SiteFooter__Section__9gpni","SiteFooter__NavBox":"SiteFooter_SiteFooter__NavBox__x0GIw","SiteFooter__Nav":"SiteFooter_SiteFooter__Nav__DU5vs","SiteFooter__NavTitle":"SiteFooter_SiteFooter__NavTitle__exdVq","SiteFooter__NavList":"SiteFooter_SiteFooter__NavList__GC1aw","SiteFooter__NavListItem":"SiteFooter_SiteFooter__NavListItem__uSd4i","SiteFooter__NavListLink":"SiteFooter_SiteFooter__NavListLink__JU9IX","SiteFooter__BottomNav":"SiteFooter_SiteFooter__BottomNav__bEekv","SiteFooter__BottomNavList":"SiteFooter_SiteFooter__BottomNavList__WVOzu","SiteFooter__BottomNavListItem":"SiteFooter_SiteFooter__BottomNavListItem__KPwoZ","SiteFooter__Copyright":"SiteFooter_SiteFooter__Copyright__Lyl2H"};

/***/ }),

/***/ 60267:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GlobalFooter":"GlobalFooter_GlobalFooter__gcxw1"};

/***/ }),

/***/ 49939:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterAccordion":"ServiceFooterAccordion_ServiceFooterAccordion__G27vt","ServiceFooterAccordion__Head":"ServiceFooterAccordion_ServiceFooterAccordion__Head__IVdNz","ServiceFooterAccordion__Head__Brand":"ServiceFooterAccordion_ServiceFooterAccordion__Head__Brand__MBeBa","ServiceFooterAccordion__Head__Copy":"ServiceFooterAccordion_ServiceFooterAccordion__Head__Copy___YQB7","ServiceFooterAccordion__Show":"ServiceFooterAccordion_ServiceFooterAccordion__Show__rSSSG","ServiceFooterAccordion__Input":"ServiceFooterAccordion_ServiceFooterAccordion__Input__0cpvO","ServiceFooterAccordion__Head__Icon":"ServiceFooterAccordion_ServiceFooterAccordion__Head__Icon__lJd6i"};

/***/ }),

/***/ 78561:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterLogo":"ServiceFooterLogo_ServiceFooterLogo__MxeyE","ServiceFooterLogo__Logo":"ServiceFooterLogo_ServiceFooterLogo__Logo__0cnl7","ServiceFooterLogo__LogoImg":"ServiceFooterLogo_ServiceFooterLogo__LogoImg__qfds8"};

/***/ }),

/***/ 37412:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterSectionBody":"ServiceFooterSectionBody_ServiceFooterSectionBody__JOhbm"};

/***/ }),

/***/ 72897:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterSectionRow":"ServiceFooterSectionRow_ServiceFooterSectionRow__yWMKB","ServiceFooterSectionRow__Head":"ServiceFooterSectionRow_ServiceFooterSectionRow__Head__9OIA0","ServiceFooterSectionRow__BodyList":"ServiceFooterSectionRow_ServiceFooterSectionRow__BodyList__lHehg","ServiceFooterSectionRow__BodyListItem":"ServiceFooterSectionRow_ServiceFooterSectionRow__BodyListItem__18uhm","ServiceFooterSectionRow__BodyListItemLast":"ServiceFooterSectionRow_ServiceFooterSectionRow__BodyListItemLast__uURdb"};

/***/ }),

/***/ 88526:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ServiceFooterSingleHeadingAccordion":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__0TNnN","ServiceFooterSingleHeadingAccordion__Head":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Head__XC4pY","ServiceFooterSingleHeadingAccordion__Head__Brand":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Head__Brand__YnWyn","ServiceFooterSingleHeadingAccordion__Head__Copy":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Head__Copy__oeIL2","ServiceFooterSingleHeadingAccordion__Show":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Show__D3fHs","ServiceFooterSingleHeadingAccordion__Input":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Input__Czc5d","ServiceFooterSingleHeadingAccordion__Head__Icon":"ServiceFooterSingleHeadingAccordion_ServiceFooterSingleHeadingAccordion__Head__Icon__kLBq1"};

/***/ })

}]);